import { LibraryModelVersion } from './types';

/**
 * Standard AI (default) library models run on every document and cannot take
 * a user-chosen scope. Sylvanus marks them with `stdai_key`.
 */
export const isStandardAiLibraryModel = (model: LibraryModelVersion) =>
  Boolean(model.stdaiKey);

export const isScopableLibraryModel = (model: LibraryModelVersion) =>
  !isStandardAiLibraryModel(model);
